<template>
  <div class="calcRoi-result">
    <div class="calcRoi-result-board">
      <div class="calcRoi-resultTitle">
        Your expected ROI from using Data-driven Creative
      </div>
      <div class="calcRoi-resultData">
        <div class="row">
          <div class="col col-auto">
            <div class="res-data">
              <div class="res-data-img">
                <img src="./../assets/budget-saved.svg" alt="" />
              </div>
              <div class="res-data-num res-data-budget">
                {{ budgetSaved }}
              </div>
              <div class="res-data-label">Budget saved</div>
            </div>
          </div>
          <div class="col col-auto">
            <div class="res-data">
              <div class="res-data-img">
                <img src="./../assets/hours-saved.svg" alt="" />
              </div>
              <div class="res-data-num res-data-hours">
                {{ hoursSaved }}
              </div>
              <div class="res-data-label">Hours saved</div>
            </div>
          </div>
        </div>
      </div>
      <div class="calcRoi-resultRow row calcRoi-resultNoted">
        <div class="col-12">
          *The calculations in this calculator are an estimate only
        </div>
      </div>
    </div>
    <div
      class="calcRoi-resultRow row justify-content-center form-btn"
      v-if="!contactFormShow"
    >
      <div class="col-sm-auto">
        <button
          class="btn btn-primary contact-fs-after-calculation"
          @click.prevent="contactHandler"
        >
          Contact FiveStones
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalculateROIResult',
  props: {
    budgetSaved: { type: String, requeried: true },
    hoursSaved: { type: String, requeried: true },
    contactFormShow: { Boolean, requeried: true }
  },
  methods: {
    contactHandler() {
      this.$emit('update:contactFormShow', true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CalculateROIResult.vue